import { gsap } from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { fadeIn, animateObserver } from "../../../js/animations/animations";

(() => {
  const BRHTripadvisorReviews = () => {
    const selectors = {
      component: ".brh-tripadvisor-reviews",
      container: ".js-brh-tripadvisor-reviews__wrapper",
      slidersContainer: ".js-brh-tripadvisor-reviews__sliders",
      score: ".js-brh-tripadvisor-reviews__ratesblock-score",
      dots: ".js-brh-tripadvisor-reviews__ratesblock-dots",
      numberReviews: ".js-brh-tripadvisor-reviews__ratesblock__social-number",
    };

    const selectorReview = {
      container: ".js-brh-tripadvisor-reviews__review",
      title: ".js-brh-tripadvisor-reviews__review-title",
      description: ".js-brh-tripadvisor-reviews__review-description",
      name: ".js-brh-tripadvisor-reviews__review-name",
      date: ".js-brh-tripadvisor-reviews__review-date",
    };

    const classes = {
      hide: "mod--hidden",
      completeContainer: "brh-composition-awards__wrapper--full",
      dot: "brh-tripadvisor-reviews__ratesblock-dot",
      fullDot: "brh-tripadvisor-reviews__ratesblock-dot--full",
      halfDot: "brh-tripadvisor-reviews__ratesblock-dot--half",
      emptyDot: "brh-tripadvisor-reviews__ratesblock-dot--empty",
    };

    const updateReviews = (reviewTpl, reviews, swiper) => {
      // Clear the container
      const slidesContainer = reviewTpl.parentElement;
      slidesContainer.innerHTML = "";

      // Prepare fragment
      const frag = document.createDocumentFragment();

      reviews.forEach((user) => {
        const slide = reviewTpl.cloneNode(true);

        //------------------------------ Fill content -----------------------------------//

        const titleElement = slide.querySelector(selectorReview.title);
        if (titleElement) {
          titleElement.textContent = user.title;
        }

        const descriptionElement = slide.querySelector(selectorReview.description);
        if (descriptionElement) {
          descriptionElement.textContent = user.text;
        }

        const nameElement = slide.querySelector(selectorReview.name);
        if (nameElement) {
          nameElement.textContent = user.user.username;
        }

        //------------------------------------------------------------------------------//

        slide.querySelector(selectorReview.date).textContent = new Date(user.published_date).toLocaleDateString(document.documentElement.lang, {
          year: "numeric",
          month: "short",
          day: "numeric",
        });

        slide.classList.remove("swiper-slide-active");
        slide.classList.remove("swiper-slide-fully-visible");
        slide.classList.remove("swiper-slide-visible");
        frag.appendChild(slide);
      });

      // Insert all slides into the container
      slidesContainer.appendChild(frag);

      //  Update Swiper to recalculate sizes and positions
      if (swiper && typeof swiper.update === "function") {
        swiper.update();
      }
    };

    const updateInfo = (data, container, swiper) => {
      const { rating: rawRating, num_reviews: totalReviews, reviews } = data;
      const rating = parseFloat(rawRating);

      // Calculate the average rating
      const scoreEl = container.querySelector(selectors.score);
      if (scoreEl) {
        const shouldRound = scoreEl.dataset.round === "true";
        scoreEl.textContent = shouldRound ? Math.round(rating * 10) / 10 : rating;
      }

      const dotsEl = container.querySelector(selectors.dots);
      if (dotsEl) {
        dotsEl.innerHTML = "";
        const frag = document.createDocumentFragment();

        for (let i = 1; i <= 5; i++) {
          const dot = document.createElement("div");
          dot.classList.add(classes.dot);

          // Filter by rating
          if (rating >= i) {
            dot.classList.add(classes.fullDot);
          } else if (rating >= i - 0.5) {
            dot.classList.add(classes.halfDot);
          } else {
            dot.classList.add(classes.emptyDot);
          }
          frag.appendChild(dot);
        }
        dotsEl.appendChild(frag);
      }

      // Update the number of reviews
      const numberReviews = container.querySelector(selectors.numberReviews);
      if (numberReviews) {
        numberReviews.textContent = totalReviews;
      }

      // Update the reviews
      const tplReview = container.querySelector(selectorReview.container);
      const threshold = parseFloat(container.dataset.rating) || 0;
      const filteredReviews = threshold > 0 ? reviews.filter((r) => r.rating >= threshold) : reviews;

      updateReviews(tplReview, filteredReviews, swiper);
    };

    const getInfo = (container) => {
      const href = container.dataset.href;
      if (!href) {
        console.error("Error, URL not valid.");
        return;
      }

      try {
        fetch(href)
          .then(function (response) {
            if (!response.ok) {
              throw new Error(response.status);
            } else {
              return response.json();
            }
          })
          .then(function (data) {
            updateInfo(data, container);
          })
          .catch(function (err) {
            container.classList.add(classes.hide);
            console.log(err);
          });
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };

    const initCarousel = (swiperElement) => {
      if (swiperElement) {
        new window.Swiper(swiperElement, {
          slidesPerView: 1,
          loop: true,
          freeMode: true,
          allowTouchMove: true,
          effect: "fade",
          fadeEffect: { crossFade: true },
          speed: 500,
          pagination: {
            el: ".swiper-pagination",
          },
          autoplay: {
            delay: 5000,
          },
        });
      }
    };

    const init = () => {
      const parentElement = Array.from(document.querySelectorAll(selectors.component));
      parentElement.forEach((element) => {
        const container = element.querySelector(selectors.container);
        const slidersContainer = element.querySelector(selectors.slidersContainer);
        if (container.dataset.href) {
          getInfo(container);
        }
        if (slidersContainer) {
          initCarousel(slidersContainer);
        }
      });

      //== Animations
      if (!isMobile() && !isAuthor()) {
        const bannerQuote = document.querySelectorAll(".brh-tripadvisor-reviews");
        if (bannerQuote.length > 0) {
          bannerQuote.forEach((element) => {
            const appearances = gsap.timeline();
            const slides = element.querySelectorAll(".js-tripadvisor-fadeIn");
            slides.length > 0 && appearances.add(fadeIn({ classElement: slides, duration: 2 }), 0);

            appearances.duration(1);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };
  document.addEventListener("DOMContentLoaded", BRHTripadvisorReviews);
})();
